export default __webpack_public_path__ + "static/qlab-4-icon-53aec9a72c32ab35f3f870856c815c5e.png";